module.exports = __webpack_public_path__ + "img/s6.0ffe71fc.svg";